import { createContext } from "react";

export const VideoPlayerContext = createContext();